export const notInitialized=()=>{throw new Error("uSES not initialized!")};